import NearMeIcon from '@mui/icons-material/NearMe';
import { Box, Button, IconButton } from '@mui/material';

type MapZoomControlsProps = {
  location: google.maps.LatLngLiteral;
  currentZoom: number;
  zoombuttonColor15: string;
  zoombuttonColor18: string;
  zoombuttonColor20: string;
  onZoomChange: (zoom: number) => void;
  onCenterChange: (center: google.maps.LatLngLiteral) => void;
};

export const MapZoomControls: React.FC<MapZoomControlsProps> = ({
  location,
  currentZoom,
  zoombuttonColor15,
  zoombuttonColor18,
  zoombuttonColor20,
  onZoomChange,
  onCenterChange,
}) => {
  const moveToCenter = () => {
    onCenterChange({ lat: location.lat, lng: location.lng });
  };

  const handleZoomIn = () => {
    if (currentZoom < 20) {
      onZoomChange(currentZoom + 1);
    }
  };

  const handleZoomOut = () => {
    if (currentZoom > 0) {
      onZoomChange(currentZoom - 1);
    }
  };

  const setHandleZoom = (num: number) => {
    onZoomChange(num);
  };

  return (
    <div className="map-control-shell">
      <div className="map-control-stack">
        <IconButton
          className="map-current-button"
          sx={{ marginBottom: '5px', marginLeft: '-3px', width: 70, height: 50 }}
          onClick={moveToCenter}
        >
          <Box className="map-current-dot">
            <NearMeIcon fontSize="medium" sx={{ color: '#1E90FF' }} />
          </Box>
        </IconButton>
        <Button
          className={`${zoombuttonColor15} map-zoom-option`}
          sx={{ color: 'black', marginBottom: '5px', textTransform: 'lowercase' }}
          disabled={zoombuttonColor15 === 'gray'}
          onClick={() => setHandleZoom(15)}
        >
          1km
        </Button>
        <Button
          className={`${zoombuttonColor18} map-zoom-option`}
          sx={{ color: 'black', marginBottom: '5px', textTransform: 'lowercase' }}
          disabled={zoombuttonColor18 === 'gray'}
          onClick={() => setHandleZoom(18)}
        >
          200m
        </Button>
        <Button
          className={`${zoombuttonColor20} map-zoom-option`}
          sx={{ color: 'black', marginBottom: '5px', textTransform: 'lowercase' }}
          disabled={zoombuttonColor20 === 'gray'}
          onClick={() => setHandleZoom(20)}
        >
          50m
        </Button>
        <Button
          className="u-bg-white map-zoom-option"
          sx={{ color: 'black', marginBottom: '5px' }}
          onClick={handleZoomIn}
        >
          +
        </Button>
        <Button
          className="u-bg-white map-zoom-option"
          sx={{ color: 'black', marginBottom: '5px' }}
          onClick={handleZoomOut}
        >
          -
        </Button>
      </div>
    </div>
  );
};
